/* eslint-disable guard-for-in */
import React from 'react';
import PropTypes from 'prop-types';
import { useCollection } from 'react-firebase-hooks/firestore';
import { Result } from 'antd';
import Client from 'containers/app/client';
import { LayoutGrid } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';
import { timeOptions } from 'utils/dates';
import WorkerCard from './worker-card';

import './style.css';

const WorkerSearchResults = ({ values }) => {
  const {
    rate,
    role,
    sector,
    qualifications,
    trainingCourses,
    shiftTimes,
  } = values;
  const ref = Client.db
    .collection('users')
    .where('disabled', '==', false)
    .where('info.role', '==', 'isWorker')
    .where('isProfileComplete', '==', true);

  const [snapshot, loading, error] = useCollection(ref);

  if (loading) return <LoadingFullPage />;
  if (error) throw error;



  const checkShifts = (item) => {
    // check for matching shift times
    let isMatch = false;
    if (item && item.shiftsInfo && item.shiftsInfo.dateTimeAvailable && shiftTimes) {
      // eslint-disable-next-line no-restricted-syntax
      for (const prop in item.shiftsInfo.dateTimeAvailable) {
        const shift = item.shiftsInfo.dateTimeAvailable[prop];

        for (let i = 0; i < shiftTimes.length; i += 1) {
          const idx = shiftTimes[i];
          const { startTime } = timeOptions[idx];
          const { endTime } = timeOptions[idx];

          // check for a match
          if (shift.startTime === startTime && shift.endTime === endTime) {
            isMatch = true;
            break;
          }
        }
      }
    }

    return isMatch;
  }

  const checkRate = (item) => {
    if (item && item.shiftsInfo && item.shiftsInfo.hourRate) return item.shiftsInfo.hourRate[0] <= rate
    return false;
  }

  const checkForMatches = (list, listToMatch) => {
    // check for matching qualifications
    let isMatch = false;
    if (list && listToMatch) {
      // count how many qualifications we need to match from the list passed in
      const howManyToMatch = listToMatch.length;
      let howManyMatched = 0;

      // eslint-disable-next-line no-restricted-syntax
      for (const prop in list) {
        const item = list[prop];

        // check for a valid entry from the user
        if (item) {
          for (let i = 0; i < howManyToMatch; i += 1) {
            if (listToMatch[i] === prop) {
              // add to the matches
              howManyMatched += 1;
            }
          }
        }
      }

      // check we meet the right amount of matches needed
      if (howManyMatched === howManyToMatch) isMatch = true;
    }

    return isMatch;
  }

  const filteredItems = snapshot.docs.filter((doc) => {
    const item = doc.data();
    console.log('item', item, qualifications, trainingCourses);

    // check for values set for each item in the search criteria
    const rolesList = new Set(
      Object.values(item.jobRoles).map((list) => list.role)
    );
    const sectorsList = new Set(
      Object.values(item.jobRoles).map((list) => list.sector)
    );

    const isRateMax = checkRate(item);
    const isRole = rolesList.has(role) || false;
    const isSector = sectorsList.has(sector) || false;
    const isShift = checkShifts(item);
    const isQualified = checkForMatches(item.qualifications, qualifications);
    const isTrained = checkForMatches(item.mandatoryCourses, trainingCourses);

    return isRateMax && isRole && isSector && isShift && isQualified && isTrained;
  });

  const shuffleArray = (arr) => {
    // eslint-disable-next-line no-plusplus
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = arr[i];

      // eslint-disable-next-line no-param-reassign
      arr[i] = arr[j];
      // eslint-disable-next-line no-param-reassign
      arr[j] = temp;
    }
    return arr;
  };

  if (filteredItems.length === 0)
    return (
      <div className="no-results-wrapper">
        <Result title="No results found, try changing your filters." />
      </div>
    );

  return (
    <LayoutGrid>
      {shuffleArray(filteredItems).map((doc) => {
        const data = doc.data();
        return (
          <WorkerCard
            key={doc.id}
            id={doc.id}
            info={data.info}
            mainAddress={data.mainAddress}
            experience={data.experience}
            mandatoryCourses={data.mandatoryCourses}
            qualifications={data.qualifications}
            isFakeUser={data.isFakeUser}
            shiftsInfo={data.shiftsInfo}
            jobRoles={data.jobRoles}
          />
        );
      })}
    </LayoutGrid>
  );
};

WorkerSearchResults.propTypes = {
  values: PropTypes.shape({
    rate: PropTypes.number,
    role: PropTypes.string,
    sector: PropTypes.string,
    qualifications: PropTypes.array,
    trainingCourses: PropTypes.array,
    shiftTimes: PropTypes.array,
  }).isRequired,
};

export default WorkerSearchResults;
